import { DepositoService } from "../../services/deposito/depositoService";
import { CalcularImpostoRequest } from "domain/types/_carteira/deposito/calcularImpostoRequest";

import { DepositoCreditoRequest } from "domain/types/_carteira/deposito/depositoCreditoRequest";
import { DepositoDebitoRequest } from "domain/types/_carteira/deposito/depositoDebitoRequest";
import { DepositoPixRequest } from "domain/types/_carteira/deposito/depostioPixRequest";
import { DepositoComponentProps } from "../../views/Deposito";

export interface DepositoContainerProps { }

export default class DepositoContainer {
  public props: DepositoComponentProps

  constructor(props: DepositoComponentProps) {
    this.props = props
  }

  async AbrirBoleto(url: string) {
    const _DepositoService = new DepositoService();

    _DepositoService.AbrirBoleto(url)
  }

  async DepositoPix(request: DepositoPixRequest, callback: () => void) {
    this.props.DepositoPix(request, callback)
  }

  // async DepositoBoleto(request: DepositoBoletoRequest, callback: () => void) {
  //   this.props.DepositoBoleto(request, callback)
  // }

  async DepositoDebito(request: DepositoDebitoRequest, callback: () => void) {
    this.props.DepositoDebito(request, callback)
  }

  async DepositoCredito(request: DepositoCreditoRequest, callback: () => void) {
    this.props.DepositoCredito(request, callback)
  }

  async CalcularImposto(request: CalcularImpostoRequest, carteiraId: number) {
    this.props.CalcularImposto(request, carteiraId)
  }

  async GetMeioPagamento(carteiraId: number) {
    this.props.GetMeioPagamento(carteiraId);
  }

  async GetBoletos(carteiraId: number) {
    this.props.GetBoletos(carteiraId);
  }

}
